import {
  ReadonlyBlock,
  ReadonlyLabel,
  ReadonlyField,
  ReadonlyFieldRow,
  ReadonlyFieldLabel,
} from '@/forms-legacy'
import { ConvertSpeed } from '@/components/smartUtils/conversion/ConvertSpeed'

import { useTexts } from './hooks/useTexts'

interface Props {
  speed: number
}

export function Speed(props: Props) {
  const { speed } = props

  const texts = useTexts()

  return (
    <ReadonlyBlock half>
      <ReadonlyLabel>{texts.speed}</ReadonlyLabel>
      <ReadonlyField>
        <ReadonlyFieldRow>
          <ReadonlyFieldLabel>
            <ConvertSpeed metersPerSeconds={speed} decimals={0} />
          </ReadonlyFieldLabel>
        </ReadonlyFieldRow>
      </ReadonlyField>
    </ReadonlyBlock>
  )
}
